import { useTranslation } from 'react-i18next';

export const ns = 'event-details-page';
export const useEventDetailsPageTranslation = () => useTranslation(ns);

export const ruRu = ({
  [ns]: {
    title: 'Детали события',
    archive: 'Архив событий обнаружение и совпадение',
    title_detection: 'Обнаружение',
  },
}) as Record<string, unknown>;

export const en = ({
  [ns]: {
    title: 'Event details',
    archive: 'Event archive detection and matching',
    title_detection: 'Detection',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [ns]: {
    title: 'Detalles del evento',
    archive: 'Archivo de eventos detección y coincidencia',
    title_detection: 'Detección',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [ns]: {
    title: 'Detalhes do evento',
    archive: 'Arquivo de eventos detecção e correspondência',
    title_detection: 'Detecção',
  },
}) as Record<string, unknown>;
